module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-top-stone-path-background.fad1c421.png";